"use client";

import type { ReactNode } from "react";

type FinancialWorkSectionHeaderProps = {
  eyebrow: string;
  eyebrowIcon?: ReactNode;
  title: string;
  description: string;
  /** Status chip (e.g. LINE OA · Google Sheets). */
  status?: ReactNode;
  /** Primary CTA (e.g. เตรียมส่งบัญชี). Full-width under the intro on compact. */
  action?: ReactNode;
  wide: boolean;
  className?: string;
  "data-testid"?: string;
};

/** Shared page intro for งานเงิน / ข้อมูล — eyebrow, title, description, optional actions. */
export function FinancialWorkSectionHeader({
  eyebrow,
  eyebrowIcon,
  title,
  description,
  status,
  action,
  wide,
  className,
  "data-testid": testId,
}: FinancialWorkSectionHeaderProps) {
  return (
    <div
      className={
        className
          ? `flex min-w-0 flex-col gap-2 ${className}`
          : "flex min-w-0 flex-col gap-2"
      }
      data-testid={testId}
    >
      <div className="flex items-center gap-1.5 text-xs font-medium text-aera-amberdark">
        {eyebrowIcon}
        <span>{eyebrow}</span>
      </div>
      <div
        className={
          wide
            ? "flex items-end justify-between gap-4"
            : "flex flex-col gap-3"
        }
      >
        <div className="min-w-0">
          <h1 className="text-2xl font-bold tracking-tight text-aera-charcoal">
            {title}
          </h1>
          <p className="mt-1 text-sm leading-relaxed text-aera-gray">
            {description}
          </p>
          {!wide && status ? <div className="mt-2">{status}</div> : null}
        </div>
        {wide && (status || action) ? (
          <div className="flex shrink-0 items-end justify-end gap-3">
            {status}
            {action}
          </div>
        ) : null}
      </div>
      {!wide && action ? action : null}
    </div>
  );
}
